/**
 * Human labels for Eisenhower support_action (and legacy recommended_action).
 * Prefer decision.support_action when present — recommended_action is deprecated.
 */

export const SUPPORT_ACTION_LABELS = {
  call_or_dispatch: 'Позвонить / выезд',
  mosru_act_via_uk: 'Акт контрольных показаний через УК',
  assist_data_fix: 'Помочь исправить данные',
  assist_credentials: 'Проверить логин/пароль ЛК',
  planned_site_visit: 'Плановый выезд',
  planned_battery_replacement_warranty: 'Плановая замена батареи (гарантия)',
  battery_replacement: 'Заменить батарею (гарантия)',
  assist_self_replace: 'Помочь с заменой батареи',
};

export const LEGACY_ACTION_LABELS = {
  none: 'Не требуется',
  call_user: 'Позвонить пользователю',
  call_user_same_day: 'Позвонить сегодня',
  contact_user_7d: 'Позвонить в течение 7 дней',
  dispatch_specialist: 'Направить специалиста',
  manual_check: 'Ручная проверка',
  escalate_uk: 'Эскалировать в УК',
  field_power_check_same_day: 'Выезд или проверка сегодня',
  collect_battery_data: 'Нужно больше данных с прибора',
  mosru_act_via_uk: 'Акт контрольных показаний через УК',
  monitor_signal: 'Наблюдать сигнал',
  monitor_battery: 'Пока только наблюдать',
  watch_battery_telemetry: 'Пока только наблюдать',
  check_battery: 'Проверить питание',
  power_check_7d: 'Проверить питание в течение 7 дней',
  accelerated_power_diagnostics_48h: 'Срочно проверить питание (48 ч)',
  replace_battery: 'Заменить батарею после проверки',
};

/** Resolve operator-facing action text from rule_result (+ decision). */
export function resolveSupportActionLabel(ruleResult) {
  const decision = ruleResult?.decision || {};
  const supportAction = decision.support_action;
  if (supportAction) {
    return SUPPORT_ACTION_LABELS[supportAction] || supportAction;
  }
  if (decision.quadrant === 'C' && decision.auto_notify_eligible) {
    return 'Авто: уведомить клиента';
  }
  if (decision.quadrant === 'D' && decision.primary_owner === 'engineering') {
    return 'Инженерия';
  }
  const legacy = ruleResult?.recommended_action;
  if (legacy) {
    return LEGACY_ACTION_LABELS[legacy] || legacy;
  }
  return '—';
}
